export function pluralizeString(text, count, singular, plural, wordIfNotNumber = null) {
  if (isNaN(count)) {
    return [text, count, wordIfNotNumber].join(' ')
  }
  if (count === 1) {
    return [text, count, singular].join(' ')
  }

  return [text, count, plural].join(' ')
}
